import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Products14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_185)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.40909 0.25C3.76894 0.25 3.25 0.768943 3.25 1.40909V9.59091C3.25 10.2311 3.76894 10.75 4.40909 10.75H12.5909C13.2311 10.75 13.75 10.2311 13.75 9.59091V1.40909C13.75 0.768943 13.2311 0.25 12.5909 0.25H4.40909ZM4.75 9.25V4.75H12.25V9.25H4.75ZM6.25 3.25H4.75V1.75H6.25V3.25ZM7.75 3.25H12.25V1.75H7.75V3.25Z'
        fill='currentColor'
      />
      <path
        d='M1.75 4.5V12.25H9.5V13.75H1.40909C0.781672 13.75 0.25 13.2303 0.25 12.6V4.5H1.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_185'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Products14.displayName = 'Products14';
export default Products14;
